import React from "react"

import { Link, LinkProps } from "./Link"

export const DownloadLink: React.FC<LinkProps> = ({
  onClick,
  ...linkProps
}): React.ReactElement => {
  const onClickHandler = (...args: Parameters<typeof onClick>): void => {
    analytics.track("Download Button Clicked")

    if (onClick) onClick(...args)
  }

  return <Link onClick={onClickHandler} {...linkProps} />
}
